<template>
	<div class="about">
    <base-banner
			:title="banner.title"
			:caption="banner.caption"
			:backgroundImage="banner.image"
			:titleColor="banner.titleColor"
			:captionColor="banner.captionColor"
			:backgroundColor="banner.backgroundColor"
      :buttons="banner.buttons"
		>
		</base-banner>

		<base-goto :breadcrumbs="breadcrumbs"></base-goto>
    
    <base-divider></base-divider>

    <div id="content">
      <div id="telemedicine" class="sec white-bg">
        <v-container fill-height>
          <v-row justify="center" class="text-center">
            <v-col cols="12">
              <p
                class="font-weight-black blue--text"
                :class="MIXIN_SETUP_UI.header"
                data-aos="fade-up"
              >
                What is Telemedicine?
              </p>
            </v-col>
            <v-col cols="12">
              <v-img
                contain
                src="@/assets/images/aboutus_1.png"
                :height="MIXIN_SETUP_UI.components.ABOUT_PAGE.image.height.small"
                data-aos="fade-up"
              ></v-img>
            </v-col>
            <v-col cols="12">
              <p data-aos="fade-up">Telemedicine is a healthcare delivery model established over 40 years ago, beginning as a way for<br>hospital to extend care to patients in remote areas. Through technologies advances, it has<br>transformed into an efficient and convenient model of care.</p>
            </v-col>
          </v-row>
        </v-container>
      </div>

      <div id="medgate" class="sec-5"  :class="MIXIN_SETUP_UI.defaultSideMargin">
        <v-row align="center" justify="center">
          <v-card
            rounded="xl"
            flat
            width="800px"
            data-aos="fade-up"
          >
            <v-container class="card">
              <v-row justify="center" class="text-center">
                <v-col cols="12">
                  <p
                    class="font-weight-black blue--text"
                    :class="MIXIN_SETUP_UI.header"
                  >
                    This is Medgate
                  </p>
                </v-col>
                <v-col cols="12">
                  <v-img
                    contain
                    src="@/assets/images/aboutus_2.png"
                    :height="MIXIN_SETUP_UI.components.ABOUT_PAGE.image.height.medium"
                  >
                  </v-img>
                </v-col>
                <v-col cols="12">
                  <p>Founded in 1998 in Switzerland, Medgate is the leading international provider of telemedicine, with operations in Switzerland, the Middle East, India, and the Philippines.</p>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-row>
      </div>

      <div id="mission" class="blue-bg">
        <v-container fill-height>
          <v-row justify="center">
            <v-col
              cols="12" sm="12" md="6" lg="4" xl="4"
              data-aos="fade-right"
            >
              <v-img
                src="@/assets/images/aboutus_3.png"
                :width="MIXIN_SETUP_UI.components.ABOUT_PAGE.image.width.medium"
                class="mx-auto"
              ></v-img>
            </v-col>
            <v-col
              cols="12" sm="12" md="6" lg="4" xl="4"
              data-aos="fade-up"
            >
              <v-container fill-height>
                <v-row align="center" justify="center">
                  <v-col cols="12">
                    <div
                      :class="[ { 'text-center' : $vuetify.breakpoint.smAndDown },'font-weight-black', MIXIN_SETUP_UI.header ]"
                    >
                      Our Mission
                    </div>
                  </v-col>
                  <v-col cols="12">
                    <div :class="[ { 'text-center' : $vuetify.breakpoint.smAndDown }, MIXIN_SETUP_UI.title ]">Innovative healthcare made easy.</div>
                  </v-col>
              </v-row>
              </v-container>
            </v-col>
          </v-row>
        </v-container>
      </div>

      <div id="values" class="sec">
        <v-container>
          <v-row justify="center">
            <div
              class="head font-weight-bold"
              data-aos="fade-up"
              :class="MIXIN_SETUP_UI.header"
            >
              Our Values
            </div>
          </v-row>

          <v-row justify="center">
            <v-col
              cols="12" sm="12" md="6" lg="6" xl="6"
              v-for="(val, key) in values"
              :key="key"
            >
              <v-row
                justify="center"
                class="text-center"
                data-aos="fade-up"
              >
                <v-col cols="12">
                  <div
                    class="primary--text font-weight-bold"
                    :class="MIXIN_SETUP_UI.header"
                  >
                  {{ val.title }}
                </div>
                </v-col>
                <v-col cols="12">
                  <v-img
                    contain
                    :src="val.backgroundImage"
                    :height="MIXIN_SETUP_UI.components.ABOUT_PAGE.image.height.medium"
                  ></v-img>
                </v-col>
                <v-col cols="12">
                  <p>{{ val.description }}</p>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </div>

      <base-divider></base-divider>

      <div id="programs" class="sec">
        <v-container :class="MIXIN_SETUP_UI.defaultSidePadding">
          <v-row justify="center">
            <div
              class="font-weight-bold head"
              data-aos="fade-up"
              :class="MIXIN_SETUP_UI.header"
            >
              Tele-Treatment Program
            </div>
          </v-row>

          <!-- <v-row class="card" justify="center">
            <v-col
              cols="12" sm="12" md="6" lg="6" xl="6"
              v-for="(val, key) in programs"
              :key="key"
              class="d-flex"
            >
              <v-row
                align="center"
                data-aos="fade-up"
              >
                <v-col cols="2">
                  <v-img :src="val.backgroundImage" width="100%"></v-img>
                </v-col>
                <v-col cols="10">
                  <span>{{ val.description }}</span>
                </v-col>
              </v-row>
            </v-col>
          </v-row> -->

          <v-row class="card" justify="center">
            <v-col
              cols="12" sm="12" md="6" lg="6" xl="6"
              v-for="(val, key) in programs"
              :key="key"
            >
              <div
                class="d-flex align-center"
                :class="[{ 'flex-column': MIXIN_SETUP_UI.components.ABOUT_PAGE.stackPhotoDescription }]"
              >
                <div>
                  <v-img
                    :src="val.backgroundImage"
                    contain
                    height="100"
                    width="100%"
                  ></v-img>
                </div>
                <span>{{ val.description }}</span>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </div>

      <partners-section></partners-section>

      <div id="awards" class="sec">
        <v-container>
          <v-row justify="center">
            <div
              class="display-2 head"
              data-aos="fade-up"
            >
              Awards
            </div>
          </v-row>

          <v-row>
            <v-row>
              <v-col
                v-for="(award, key) in awards"
                :key="key"
                cols="12" sm="12" md="4" lg="4" xl="4"
                data-aos="fade-up"
              >
                <v-img :src="award"></v-img>
              </v-col>
            </v-row>
          </v-row>
        </v-container>
      </div>
    </div>
  </div>
</template>

<script>
import PartnersSection from "@/components/home/PartnersSection.vue";

import Repository from "@/api/repositories";
const AboutBannersApi = Repository.get("aboutBanners");
const AboutProgramsApi = Repository.get("aboutPrograms");
const AboutSectionsApi = Repository.get("aboutSections");

export default {
  name: "About",
  components: {
    PartnersSection
  },
  data() {
    return {
      banner: [],
      values: [],
      programs: [],
      breadcrumbs: [
				{
					name: "Medgate",
					link: "/",
					active: false
				},
				{
					name: "About Medgate",
					link: "/about",
					active: true
        }
      ],
      awards: [
        require("@/assets/images/awards/award2019.png"),
        require("@/assets/images/awards/award2020-01.png"),
        require("@/assets/images/awards/award2020-02.png")
      ]
		}
  },
  async mounted() {
    this.getAboutSections();
    this.getAboutPrograms();
    await this.getAboutBanner();
    this.setHeaderColor();
  },
  methods: {
    setHeaderColor() {
      if (this.banner.backgroundColor)
        this.$store.commit('page/setHeaderColor', this.banner.backgroundColor)
      else
        this.$store.commit('page/defaultHeaderColor')
    },
    async getAboutBanner() {
      try {
        const { data } = await AboutBannersApi.get();
        
        if (data) {
          data.data.sort(function(a, b) {
            return a.precedence - b.precedence;
          });
          
          let apiData = data.data[0];

          let buttons = apiData.buttons.map(button => {
            return {
              name: button.label,
              icon: button.image,
              link: button.redirect,
              color: JSON.parse(button.styling).color
            }
          });

          let banner = {
            buttons: buttons,
            image: apiData.background_image.main,
            caption: apiData.caption,
            title: apiData.title,
            titleColor: apiData.styles.titleColor,
            captionColor: apiData.styles.captionColor,
            backgroundColor: apiData.styles.backgroundColor
          }

          this.banner = banner;
        }

        console.log('[about-banner]', data, this.banner);
      }
      catch(error) {
        console.log(error);
      }
    },
    async getAboutSections() {
      try {
        const { data } = await AboutSectionsApi.get();
        
        if (data) {
          data.data.sort(function(a, b) {
            return a.precedence - b.precedence;
          });

          let sections = data.data.map(section => {
            return {
              title: section.title,
              description: section.description,
              backgroundImage: section.background_image.main
            }
          });

          this.values = sections;
        }

        console.log('[about-sections]', data, this.values);
      }
      catch(error) {
        console.log(error);
      }
    },
    async getAboutPrograms() {
      try {
        const { data } = await AboutProgramsApi.get();
        
        if (data) {
          data.data.sort(function(a, b) {
            return a.precedence - b.precedence;
          });

          let programs = data.data.map(program => {
            return {
              title: program.title,
              description: program.description,
              backgroundImage: program.background_image.main
            }
          });

          this.programs = programs;
        }

        console.log('[about-programs]', data, this.programs);
      }
      catch(error) {
        console.log(error);
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/variables.scss";

// #header {
// 	height: 750px;
// 	background: $blue;
// }

#telemedicine {
  min-height: 380px;
}

#medgate {
  min-height: 590px;

  .card {
    padding: 5%;
  }
}

#mission {
  height: 500px;
}

#values, #programs, #awards {
  background: $light-gray;
}

#programs {
  .card {
    padding-left: 2%;
    padding-right: 2%;

    span {
      font-size: small;
    }
  }
}
</style>